import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import type { WebsiteContentStatus } from '../graphql/types';

const STATUS_COLORS: Record<WebsiteContentStatus, string> = {
    DRAFT: 'default',
    SCHEDULED: 'blue',
    PUBLISHED: 'green',
    OFFLINE: 'orange',
};

interface ContentStatusTagProps {
    content: { status: WebsiteContentStatus; hasUnpublishedChanges?: boolean };
}

/** 状态标签；已发布但草稿有改动时追加「有未发布的修改」 */
const ContentStatusTag: React.FC<ContentStatusTagProps> = ({ content }) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-start gap-1">
            <Tag color={STATUS_COLORS[content.status]}>{t(`websiteContent.status.${content.status}`)}</Tag>
            {content.status === 'PUBLISHED' && content.hasUnpublishedChanges && (
                <span className="text-xs text-orange-500">{t('websiteContent.list.unpublishedChanges')}</span>
            )}
        </div>
    );
};

export default ContentStatusTag;
